import { useCallback } from 'react';
import PropTypes from 'prop-types';
import debounce from 'debounce-promise';

/**
 * Promise version of useDebounced version. Can be used with react-select
 * library for debouncing loadOptions.
 *
 * Inspired from:
 * https://github.com/JedWatson/react-select/issues/3075#issuecomment-450194917
 *
 * Pass on a function, wait time, and dependecies for useCallback,
 * and it returns a debounced version of the function as a promise.
 */
function useDebouncedPromise(fn, wait, deps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce(fn, wait, { trailing: true, leading: false }),
    deps
  );
}

useDebouncedPromise.propTypes = {
  fn: PropTypes.func.isRequired,
  wait: PropTypes.number.isRequired,
  deps: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default useDebouncedPromise;
